import { z, ZodTypeAny } from 'zod';

const options = [
    { value: 'passive', label: 'Passive' },
    { value: 'forced-air', label: 'Forced Air' },
    { value: 'liquid', label: 'Liquid' },
    { value: 'none', label: 'None' },
];

const CoolingMethod: {
    validator: ZodTypeAny;
    options: {
        value: string;
        label: string;
    }[];
} = {
    // @ts-ignore
    validator: z.enum(options.map((option) => option.value)),
    options,
};

export { CoolingMethod };
